'use strict';

$ = jQuery;

/*
* Evento de clique nos cards da carroceria
*/
$('#jc-carrocerias-slider').on('click', '.jc-card-bodywork a', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Carroceria',
    'eventLabel': $(this).text().trim()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Carroceria',
    'eventLabel': $(this).text().trim()
  });
});